module.exports = __webpack_public_path__ + "img/space_dust_orange_back.1728f963.jpg";